export const enumLineItemGroupName = {
  Deductions: 'Deductions',
  FreightCharges: 'Freight Charges',
} as const;

export type LineItemGroupName =
  (typeof enumLineItemGroupName)[keyof typeof enumLineItemGroupName];

const SIMPLE_GROUPS = new Set<string>(Object.values(enumLineItemGroupName));

export function isSimpleGroup(groupName: string | null): boolean {
  return groupName != null && SIMPLE_GROUPS.has(groupName);
}
